import { createSlice } from "@reduxjs/toolkit";
import { isTokenExpiringBeyond8Days } from "../utils/Auth";

interface User {
	id: number;
	firstName: string;
	lastName: string;
	userRoleId: number;
	userRole: string;
	password: string | null;
}

interface AuthState {
	user?: User;
	token?: string;
}

const initialState: AuthState = {
	user: undefined,
	token: undefined,
};

const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		login: (state, action) => {
			state.user = action.payload.user;
			state.token = action.payload.token;
		},
		logout: (state) => {
			state.user = undefined;
			state.token = undefined;
			localStorage.removeItem("token");
		},
		checkTokenExpirationDate: (state) => {
			const expireToken = isTokenExpiringBeyond8Days();
			if (expireToken) {
				state.user = undefined;
				state.token = undefined;
				localStorage.removeItem("token");
			}
		},
	},
});

export const { login, logout, checkTokenExpirationDate } = authSlice.actions;

export default authSlice.reducer;
